module.exports = __webpack_public_path__ + "od-pdp-try-on/od-pdp-try-on-8ad0197c3d18559125a71265b9d8608d.png";